import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { toastSuccessMessage, toastErrorMessage } from "../utils/utils";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/user/index";
import { Button, Card } from "react-bootstrap";
import { IoCheckmarkCircleOutline, IoAlertCircleOutline } from "react-icons/io5";

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [status, setStatus] = useState("verifying"); // verifying, success, error

    useEffect(() => {
        if (!token) {
            setStatus("error");
            return;
        }

        const verifyToken = async () => {
            dispatch(SET_LOADING(true));
            try {
                const response = await API.get(`${api_paths.auth.VERIFY_EMAIL}?token=${token}`);
                if (response.status === 200) {
                    setStatus("success");
                    toastSuccessMessage(response.data?.message || "Email verified successfully!");
                }
            } catch (error) {
                setStatus("error");
                toastErrorMessage(error?.response?.data?.message || "Verification failed. The link may be expired or invalid.");
            } finally {
                dispatch(SET_LOADING(false));
            }
        };

        verifyToken();
    }, [token, dispatch]);

    return (
        <div className="verify-email-page py-5 d-flex align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-5">
                        <Card className="shadow-lg border-0 p-4 text-center">
                            <Card.Body>
                                {status === "verifying" && (
                                    <div className="py-4">
                                        <div className="spinner-border text-primary mb-3" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <h3 className="inter-bold">Verifying your email...</h3>
                                        <p className="text-muted">Please wait while we confirm your email address.</p>
                                    </div>
                                )}

                                {status === "success" && (
                                    <div className="py-4">
                                        <IoCheckmarkCircleOutline className="text-success mb-3" size={80} />
                                        <h2 className="inter-bold text-success">Verification Successful!</h2>
                                        <p className="text-muted mb-4">Your email has been successfully verified. You can now access all features of your account.</p>
                                        <Button
                                            variant="primary"
                                            className="w-100 py-2 inter-bold"
                                            onClick={() => navigate("/dashboard")}
                                        >
                                            Go to Dashboard
                                        </Button>
                                    </div>
                                )}

                                {status === "error" && (
                                    <div className="py-4">
                                        <IoAlertCircleOutline className="text-danger mb-3" size={80} />
                                        <h2 className="inter-bold text-danger">Verification Failed</h2>
                                        <p className="text-muted mb-4">We couldn't verify your email. The link may have expired or is invalid.</p>
                                        <Button
                                            variant="primary"
                                            className="w-100 py-2 inter-bold"
                                            onClick={() => navigate("/dashboard")}
                                        >
                                            Dashboard
                                        </Button>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
